import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_648c7803 from '../styles/Thead.module.less.js';

const Thead = (props) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_648c7803);
    return (React.createElement("thead", { className: cx(className, 'container'), ...restProps }, children));
};

export { Thead };
//# sourceMappingURL=Thead.js.map
